/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
import type { Image } from './Image'
import { ImageFromJSON, ImageFromJSONTyped, ImageToJSON } from './Image'

/**
 *
 * @export
 * @interface Article
 */
export interface Article {
  /**
   *
   * @type {string}
   * @memberof Article
   */
  title: string
  /**
   *
   * @type {string}
   * @memberof Article
   */
  slug: string
  /**
   *
   * @type {string}
   * @memberof Article
   */
  category: string
  /**
   *
   * @type {string}
   * @memberof Article
   */
  publishedAt: string
  /**
   *
   * @type {string}
   * @memberof Article
   */
  readingTime: string
  /**
   *
   * @type {Array<Image>}
   * @memberof Article
   */
  thumbnail?: Array<Image>
}

/**
 * Check if a given object implements the Article interface.
 */
export function instanceOfArticle(value: object): value is Article {
  if (!('title' in value) || value['title'] === undefined) return false
  if (!('slug' in value) || value['slug'] === undefined) return false
  if (!('category' in value) || value['category'] === undefined) return false
  if (!('publishedAt' in value) || value['publishedAt'] === undefined)
    return false
  if (!('readingTime' in value) || value['readingTime'] === undefined)
    return false
  return true
}

export function ArticleFromJSON(json: any): Article {
  return ArticleFromJSONTyped(json, false)
}

export function ArticleFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): Article {
  if (json == null) {
    return json
  }
  return {
    title: json['title'],
    slug: json['slug'],
    category: json['category'],
    publishedAt: json['publishedAt'],
    readingTime: json['readingTime'],
    thumbnail:
      json['thumbnail'] == null
        ? undefined
        : (json['thumbnail'] as Array<any>).map(ImageFromJSON),
  }
}

export function ArticleToJSON(value?: Article | null): any {
  if (value == null) {
    return value
  }
  return {
    title: value['title'],
    slug: value['slug'],
    category: value['category'],
    publishedAt: value['publishedAt'],
    readingTime: value['readingTime'],
    thumbnail:
      value['thumbnail'] == null
        ? undefined
        : (value['thumbnail'] as Array<any>).map(ImageToJSON),
  }
}
